module.exports = "https://static.wagwalking.com/_next/static/images/drop-in-1-de392be19c1e27da7d3648fffa71a43e.svg";